"use strict";
const _ = require('lodash');
module.exports = (object, entityField) => {
    if (_.includes(entityField, 'article')) {
        return `${_.get(object, `${entityField}.articleNumber`)} - ${_.get(object, `${entityField}.name`)}`;
    }
    return (_.get(object, `${entityField}.name`) ||
        _.get(object, `${entityField}.orderNumber`) ||
        _.get(object, `${entityField}.customerNumber`) ||
        _.get(object, `${entityField}.invoiceNumber`) ||
        _.get(object, `${entityField}.articleNumber`) ||
        _.get(object, `${entityField}.subdomain`) ||
        _.get(object, `${entityField}.title`) ||
        _.get(object, `${entityField}.email`) ||
        _.get(object, `${entityField}.id`) ||
        '');
};
